/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Login_Method_RevokedInputs */



/**
* | output |
* | --- |
* | "Sign-in method removed" |
*
* @param {Audit_Details_Member_Login_Method_RevokedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_login_method_revoked = /** @type {((inputs?: Audit_Details_Member_Login_Method_RevokedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Login_Method_RevokedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmeldemethode entfernt")
	return /** @type {LocalizedString} */ ("Sign-in method removed")
});